import React from "react";
import Slider from "./Header/Slider";
import PriceWise from "./PriceWise";
import Collection from "./Collection";
import NewArrivals from "./NewArrivals";
import Credits from "./Credits";
import FunFacts from "./FunFacts";
import Reviews from "./Reviews";
import SocialMedia from "./SocialMedia";
import ScrollToTopButton from "../helpers/ScrollToTop";

export default function Home() {
  return (
    <div className="row px-0">
        <Slider/>
        <PriceWise/>
        <Collection/>
        <NewArrivals/>
        <Credits/>
        <FunFacts/>
        <Reviews/>
        <SocialMedia/>
        <ScrollToTopButton/>
        
    </div>
  );
}